import React from "react";
import "./Hero.css";
import CTAButton from "../CTA/CTAButton";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-content">
        <h1>
          Sofreu algum problema com o Banco? Conheça os seus direitos e tenha a
          oportunidade de virar o jogo!
        </h1>
        <h2>
          Somos especialistas na{" "}
          <span className="highlight">Defesa do Consumidor </span> em
          abusividades praticadas por instituições bancárias.
        </h2>
        <CTAButton />
      </div>
    </section>
  );
};

export default Hero;
